import React from 'react'

import ClickAwayListener from '@material-ui/core/ClickAwayListener'

if (process.env.REACT_APP_COMPONENT_NAVIGATION_CURRENCY_TOGGLE_LAYOUT === 'icon-menu') {
	require('../../../styles/css/components/currency/bk-flow-currency-toggle-icon-menu.css')
}

const BkFlowCurrencyToggleIconMenu = (props) => {
	const {
		currencyData,
		currencyMenuEvent,
		currencyOptions,
		currencyMenuVisible,
	} = props
	let currencyIcon = null

	if (currencyData) {
		if (currencyData.currencySymbol) {
			currencyIcon = currencyData.currencySymbol
		} else if (currencyData.currencyCode) {
			currencyIcon = currencyData.currencyCode
		}
	}

	return (
		<div className="bk-flow-currency-toggle icon-menu">
			<button
				className="bk-flow-currency-toggle__btn"
				onClick={() => currencyMenuEvent()}
			>
				{currencyIcon && currencyIcon}
			</button>

			{ currencyMenuVisible &&
				<ClickAwayListener onClickAway={ currencyMenuEvent }>
					<div className="bk-flow-currency-toggle__menu">
						{ currencyOptions }
					</div>
				</ClickAwayListener>
			}
		</div>
	)
}



export default BkFlowCurrencyToggleIconMenu


// WEBPACK FOOTER //
// ./src/components/currency/layouts/BkFlowCurrencyToggleIconMenu.js